import { $qs, $qsa } from '@js/utils/querySelector';
import gsap from 'gsap';



function whereNextHover(block) {
    const whereNextHover = $qs('[data-target="where-next-hover"]', block);
    const whereNextRotateShape = $qs('[data-target="where-next-rotate-shape"]', block);
    
    if (!whereNextHover) return;
    
    const container = whereNextHover.closest('.container');

    let isHovering = false;
    let timeline;

    function resetTimeline() {
        isHovering = false;
        if (timeline) timeline.kill();
        
        timeline = gsap.timeline()
            .addLabel('start')
            .to(whereNextHover, {
                x: 0,
                duration: 1,
                ease: 'power3.inOut'
            }, 'start')
            .to(whereNextRotateShape, {
                rotation: -57,
                duration: 1,
                ease: 'power3.inOut'
            }, 'start');
    }

    container.addEventListener('mousemove', (e) => {
        const containerRect = container.getBoundingClientRect();
        const hoverZoneWidth = containerRect.width * 0.1; // 10% of container width
        const isInHoverZone = e.clientX > containerRect.right - hoverZoneWidth;

        if (isInHoverZone && !isHovering) {
            isHovering = true;
            if (timeline) timeline.kill();
            
            const containerWidth = container.offsetWidth;
            const whereNextHoverWidth = whereNextHover.scrollWidth;
            const translateX = containerWidth - whereNextHoverWidth;

            timeline = gsap.timeline()
                .addLabel('start')
                .to(whereNextHover, {
                    x: translateX,
                    duration: 1,
                    ease: 'power3.inOut'
                }, 'start')
                .to(whereNextRotateShape, {
                    rotation: 0,
                    duration: 1,
                    ease: 'power3.inOut'
                }, 'start');
        } else if (!isInHoverZone && isHovering) {
            resetTimeline();
        }
    });

    container.addEventListener('mouseleave', resetTimeline);
}

function whereNext() {
    const whereNextBlock = $qs('[data-name="where-next"]');

    if (!whereNextBlock) return;

    whereNextHover(whereNextBlock);
}

export default whereNext;